import { makeRequest } from 'utils/requestLogger';

export default (id, co_teacher_to_delete_email) =>
  makeRequest('post', `/api/courses/${id}/remove_co_teacher`, {
    co_teacher_to_delete_email,
  });



// WEBPACK FOOTER //
// ./src/app/services/courses/removeCoTeacher.js